import React, { useRef, useEffect, useState } from 'react';
import './Loading.css';

const Loading = ({ show = true }) => {
  const [isVisible, setIsVisible] = useState(true);
  const videoRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (show) {
      setIsVisible(true);
      // Set a timeout to hide the loading after 7 seconds
      timeoutRef.current = setTimeout(() => {
        setIsVisible(false);
      }, 7000);
    } else {
      setIsVisible(false);
    }

    const playVideo = async () => {
      try {
        const currentVideo = videoRef.current;
        if (!currentVideo) return;
        
        // Load the video first to ensure sources are processed
        currentVideo.load();
        
        // Wait a bit for the video to load
        await new Promise(resolve => setTimeout(resolve, 100));
        
        currentVideo.currentTime = 0;
        await currentVideo.play();
      } catch (error) {
        console.log('Autoplay prevented, will play on interaction');
        const handleInteraction = () => {
          const currentVideo = videoRef.current;
          if (currentVideo) {
            currentVideo.load(); // Ensure sources are loaded
            setTimeout(() => {
              currentVideo.play().catch(console.error);
            }, 50);
          }
        };
        document.addEventListener('click', handleInteraction);
        return () => document.removeEventListener('click', handleInteraction);
      }
    };

    playVideo();

    // Cleanup function
    return () => {
      clearTimeout(timeoutRef.current);
      const currentVideo = videoRef.current;
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
    };
  }, []);

  if (!isVisible || !show) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <video 
          ref={videoRef}
          autoPlay 
          loop 
          muted 
          playsInline
          className="loading-spinner"
          width="200"
          height="200"
          onLoadedData={() => {
            // Ensure the video is ready to play
            const video = videoRef.current;
            if (video && !video.paused && !video.ended) {
              video.play().catch(console.error);
            }
          }}
          onError={() => {
            // If the first source fails, try to load the next one
            const video = videoRef.current;
            if (video) {
              video.load(); // This will try the next available source
            }
          }}
        >
          <source src="/loading.webm" type="video/webm" />
          <source src="/loading.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default Loading;